t = require('app/scripts/views/internal/teacup-with-helpers')('org_create')

module.exports = ->
  t.mustacheBlock 'freeTeamLimitExceeded', ->
    if t.mustacheVar('dontUpsell')
      t.p ->
        t.format 'your-org-is-out-of-free-teams-desktop', { domainName: t.mustacheVar('emailDomain') }
    else
      t.p ->
        t.format 'your-org-is-out-of-free-teams', { domainName: t.mustacheVar('emailDomain') }
      t.a {
        class: 'button full js-enterprise-learn-more',
        href: '/enterprise?utm_source=trello-product&utm_medium=inapp&utm_campaign=P:trello|O:trello|F:awareness|C:ptour|I:trello-enterprise-in-product|E:cloud|&app_source=exceeded_message_popover',
        target: '_blank'
      }, ->
        t.format 'enterprise-learn-more'

  t.form { class: t.classify({ hide: t.mustacheVar('freeTeamLimitExceeded') }) }, ->

    t.p '.error', { style: 'display:none' }

    t.label { for: 'org-display-name' }, ->
      t.format 'name'
    t.input '.js-autofocus.js-display-name', { type: 'text', name: 'displayName', id: 'org-display-name', value: t.mustacheVar('displayName'), dir: 'auto', maxLength: 100 }

    t.label { for: 'org-desc' }, ->
      t.format 'description-optional'
    t.textarea { id: 'org-desc', name: 'desc', dir: 'auto' }, ->
      t.text t.mustacheVar('desc')

    if t.mustacheVar('boardToAddToOrg') && t.mustacheVar('memberCount') > 1
      t.div '.check-div', ->
        t.input '.js-add-members', { type: 'checkbox', checked: true, id: 'addMembers' }
        t.label { for: 'addMembers', class: 'create-team-add-members' }, ->
          t.format 'add-the-members-of-this-board-to-the-team'

    t.input '.primary.wide.js-save', { type: 'submit', value: t.l('create') }

  t.mustacheBlockInverted 'freeTeamLimitExceeded', ->
    t.hr()

    if t.mustacheVar('isPrivateTemplate')
      t.p '.create-org-template-alert-notice', ->
        t.format 'moving-a-template'

    t.p '.quiet', ->
      t.format 'a-team-is-a-group-of-boards-and-people'

    if !t.mustacheVar('dontUpsell')
      t.p '.quiet.u-bottom', ->
        t.format 'business-class-gives-your-organization-more'
        t.text ' '
        t.a '.js-business-class', { href: '/business-class', target: '_blank' }, ->
          t.format 'learn-more'
